<template>
  <div class="coveragePage">
    <div class="top-title">Coverage Report</div>
    <!--   v-loading="loading"
        element-loading-text="Loading..." 
        :row-key="getRowKey"
         :width="flexTestCaseWidth(tableData)"
         -->
    <div class="bg">
      <div class="table-bg">
        <el-table
          stripe
          tooltip-effect="light"
          class="table"
          :data="tableData"
          ref="dragTable"
          :row-class-name="tableRowClassName"
          width="100%"
          border
          fit
          :header-cell-style="{
            background: '#F6F6F6',
            borderLeft: '0.5px solid #999999',
            borderRight: '0px solid #999999',
            borderTop: '0px solid #999999',
            borderBottom: '2px solid #999999',
          }"
          :cell-style="{
            background: '#FFFFFF',
            borderBottom: '0.5px solid #707070',
            borderRight: '0px solid #999999',
            borderLeft: '0.5px solid #999999',
          }"
          :max-height="getHeight()"
        >
          <el-table-column fixed width="60" align="center">
            <template #header>
              <div class="header-title header-no-item">NO.</div>
            </template>
            <template #default="scope">
              <div class="table-content table-no">
                {{ scope.$index + 1 }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            width="160"
            align="left"
            show-overflow-tooltip="true"
          >
            <template #header>
              <div class="header-box">
                <div class="header-title header-item">Repository</div>
                <FiltrateOpsItem :identifyTitle="headerIdentifyList[0]" :dataList="originDataList" @checkBoxSelect="checkBoxSelect"></FiltrateOpsItem>
              </div>
            </template>
            <template #default="scope">
              <div class="table-content table-layout">
                {{ scope.row.repository }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            width="150"
            align="left"
            show-overflow-tooltip="true"
          >
            <template #header>
              <div class="header-box">
                <div class="header-title header-item">PR Number</div>
                <!-- <div class="header-icon"><img src="@/assets/select-icon.png" /></div> -->
                <FiltrateOpsItem :identifyTitle="headerIdentifyList[1]" :dataList="originDataList" @checkBoxSelect="checkBoxSelect"></FiltrateOpsItem>
              </div>
            </template>
            <template #default="scope">
              <div class="table-content table-layout">
                {{ scope.row.prNumber }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            min-width="150"
            align="left"
            show-overflow-tooltip="true"
          >
            <template #header>
              <div class="header-box">
                <div class="header-title header-item">PR Title</div>
                <!-- <div class="header-icon"><img src="@/assets/select-icon.png" /></div> -->
                <FiltrateOpsItem :identifyTitle="headerIdentifyList[2]" :dataList="originDataList" @checkBoxSelect="checkBoxSelect"></FiltrateOpsItem>
              </div>
            </template>
            <template #default="scope">
              <div class="table-content table-layout">
                {{ scope.row.prTitle }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            width="170"
            align="left"
            show-overflow-tooltip="true"
          >
            <template #header>
              <div class="header-box">
                <div class="header-title header-item">Owner</div>
                <!-- <div class="header-icon"><img src="@/assets/select-icon.png" /></div> -->
                <FiltrateOpsItem :identifyTitle="headerIdentifyList[3]" :dataList="originDataList" @checkBoxSelect="checkBoxSelect"></FiltrateOpsItem>
              </div>
            </template>
            <template #default="scope">
              <div class="table-content table-layout">
                {{ scope.row.owner }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            width="150"
            align="left"
            show-overflow-tooltip="true"
          >
            <template #header>
              <div class="header-title header-item">Details</div>
            </template>
            <template #default="scope">
              <div class="table-content table-layout details-title" :style="{color: '#0077FF'}" @click="reportDo(scope.row)">
                {{ scope.row.details }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="bottom-title">{{ getSum() }}</div>
  </div>
</template>
<script>
import { getOSSFileList, getOSSUrl } from "@/request/api";
import { getUrlData } from "@/request/axiosApi"
import FiltrateOpsItem from "@/components/FiltrateOpsItem.vue";
import { RegressionStatusType, RegressionFailureType } from "@/utils/common"
export default {
  name: "coveragePage",
  data() {
    return {
      headerIdentifyList: ["repository", "prNumber", "prTitle", "owner"],
      originDataList: [
        {
          repository: "Repository-01",
          prNumber: "878",
          prTitle: "uywdisdioadas",
          owner: "dsad",
          details: "Download",
          isSelected: false,
        },
        {
          repository: "Repository-02",
          prNumber: "878",
          prTitle: "uywdisdioadas",
          owner: "dsad",
          details: "",
          isSelected: false,
        },
        {
          repository: "Repository-03",
          prNumber: "878",
          prTitle: "uywdisdioadas",
          owner: "dsad",
          details: "Download",
          isSelected: false,
        },
        {
          repository: "Repository-04",
          prNumber: "878",
          prTitle: "uywdisdioadas",
          owner: "dsad",
          details: "",
          isSelected: false,
        },
        {
          repository: "Repository-05",
          prNumber: "878",
          prTitle: "uywdisdioadas",
          owner: "dsad",
          details: "",
          isSelected: false,
        },
        {
          repository: "Repository-06",
          prNumber: "878",
          prTitle: "uywdisdioadas",
          owner: "dsad",
          details: "Download",
          isSelected: false,
        },
        {
          repository: "Repository-07",
          prNumber: "878",
          prTitle: "uywdisdioadas",
          owner: "dsad",
          details: "Download",
          isSelected: false,
        },
        {
          repository: "Repository-08",
          prNumber: "878",
          prTitle: "uywdisdioadas",
          owner: "dsad",
          details: "",
          isSelected: false,
        },
        {
          repository: "Repository-09",
          prNumber: "878",
          prTitle: "uywdisdioadas",
          owner: "dsad",
          details: "",
          isSelected: false,
        },
        {
          repository: "Repository-10",
          prNumber: "878",
          prTitle: "uywdisdioadas",
          owner: "dsad",
          details: "Download",
          isSelected: false,
        },
      ],
      tableData: [],
    };
  },
  methods: {
    getRegressionFailureType(failureType) {
      if (failureType?.toLocaleLowerCase().includes("build")) {
        return RegressionFailureType.build
      }
      else if (failureType?.toLocaleLowerCase().includes("regression")) {
        return RegressionFailureType.regression
      }
      return RegressionFailureType.none
    },
    getStatusType(status) {
      if (status?.toLocaleLowerCase().includes("failure")) {
        return RegressionStatusType.failure
      }
      return RegressionStatusType.success
    },
    getStatusColor(status) {
      if (status?.toLocaleLowerCase().includes("failure")) {
        return '#0077FF'
      }
      return '#000000'
    },
    getRowKey(row) {
      return row.testCase;
    },
    getHeight() {
      const h = `${document.documentElement.clientHeight}`;
      return h - 240;
    },
    getSum() {
      return this.tableData.length + "records";
    },
    checkBoxSelect(item) {
      console.log("checkBoxSelect === ", item)
      // const list = [...this.originDataList]
      console.log("originDataList === ", this.originDataList)
      for (const model of this.originDataList) {
        // model.isSelected = true
        const selectTitle = model[item.identifyTitle]
        if (selectTitle == item.selectTitle) {
          model.isSelected = item.item.isSelected
        }
      }
      const ll = this.originDataList.filter((m) => {
        return (m.isSelected == true)
      })      
      this.tableData = ll
    },
    //错位
    tableLayout() {
      this.$nextTick(() => {
        this.$refs.dragTable.doLayout();
      });
    },
    async reportDo(item) {
      console.log(item)
      const url = await getOSSUrl(this.$DataString.regressionBucket, "Eden/385/144/coverage_results.tar.zst")
      console.log("url = ", url)
      const list = await getOSSFileList(this.$DataString.regressionBucket, "Eden/385/144/coverage_results.tar.zst")
      console.log("list = ", list)
    }
  },
  components: {
    FiltrateOpsItem,
  },
  async created() {
    this.tableLayout();
    const list = await getOSSFileList(this.$DataString.regressionBucket, "Eden")

    this.logList = list.objects.filter((item) => {
      return item.name.includes(".log")
    })

    const list2 = list.objects.filter((item) => {
      return item.name.includes(".json")
    })

    list2.map(item => {
      const arr = item.name.split("/")
      item.prNumber = arr[1]
      item.pathNumber = arr[2]
      arr.pop()
      item.repository = arr[0]//.join("/")
    })
    
    list2.sort((m1, m2)=> {
      return m1.prNumber - m2.prNumber
    })
    console.log("list2 2222= ", list2)
    // const list3 = [...list2]
    const list4 = []
    for (const item of list2) {
      list4.push(item.prNumber)
    }
    const list5 = [... new Set(list4)]
    
    const dataList = []
    for (const prNumber of list5) {
      let maxItem = {}
      let maxPathNumber = 0
      for (const item of list2) {
        if (prNumber ==  item.prNumber) {
          if (item.prNumber >= maxPathNumber) {
            maxPathNumber = item.pathNumber
            maxItem =  item
          }
        }
      }
      const url = await getOSSUrl(this.$DataString.regressionBucket, maxItem.name)
      console.log(url)
      const jsonModel = await getUrlData(url, true);
      maxItem.prTitle = jsonModel.pr_title
      maxItem.owner = jsonModel.head_owner
      maxItem.status = jsonModel.status
      maxItem.statusType = this.getStatusType(maxItem.status)
      maxItem.commitLog = jsonModel.commit_comment
      maxItem.startTime = jsonModel.start_time
      maxItem.endTime = jsonModel.end_time
      maxItem.startTime = jsonModel.start_time
      maxItem.failureType = this.getRegressionFailureType(jsonModel.failure_type)
      maxItem.details = "Report Index"
      maxItem.isSelected = true

      dataList.push(maxItem);
    }
    this.originDataList = dataList;
    this.tableData = [...this.originDataList]

  },
};
</script>
<style lang='less' scoped>
.coveragePage {
  .top-title {
    color: #0050b3;
    font-size: 32px;
    font-weight: bold;
    text-align: left;
    padding: 30px 0px 33px 85px;
  }
  .bg {
    height: calc(100vh - 240px);
    padding: 0px 81px 0px 81px;
    .table-bg {
      height: 100%;
      border: 1px solid #e8ebf3;
    }
    .table {
      border-top: 2px solid #707070;
      border-left: 0px solid #707070;
      border-right: 0.5px solid #707070;
      border-bottom: 1.5px solid #707070;
      border-radius: 4px;
      .header-title {
        color: #000000;
        font-size: 16px;
        font-weight: 700;
        // padding-left: 10px;
      }
      .header-box {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }
      .header-icon {
        height: 14px;
        width: 14px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .table-content {
        width: 100%;
        display: flex;
        height: 50px;
        align-items: center;
        font-size: 16px;
        font-weight: 400;
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .table-no {
        justify-content: center;
      }
      .details-title {
        cursor: pointer;
      }
    }
  }
  .bottom-title {
    display: flex;
    margin-left: 81px;
    width: calc(100% - 162px);
    height: 25px;
    background-color: #f3f6f9;
    text-align: left;
    padding-left: 20px;
    color: #565656;
    font-size: 14px;
    padding-left: 30px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    align-items: center;
  }
}
:deep(.el-table .cell) {
  padding: 0px 10px 0px 10px !important;
}
:deep(.el-table td) {
  padding: 0 !important;
}
:deep(.el-table th) {
  user-select: initial !important;
}
</style>